import { ColumnDef } from "@tanstack/react-table"
import { useCallback, useState } from "react"
import XLSX from "xlsx-js-style"
import { TableLoadingStateEnum } from "./tableProps.interface"

const useTableExport = (
  footer?: any | null
): [number, (columns: ColumnDef<any>[], rows: any[][]) => void] => {
  const [state, setState] = useState<TableLoadingStateEnum>(2)

  const exportTable = useCallback((columns: ColumnDef<any>[], rows: any[][]) => {
    setState(1)
    setTimeout(() => {
      try {
        let newColumns: string[] = []

        columns.forEach((col) => {
          newColumns.push(col.header as string)
        })

        let data = rows.slice()
        data.unshift(newColumns)

        const ws = XLSX.utils.aoa_to_sheet(data)

        // autofilter range
        const range = XLSX.utils.decode_range(ws["!ref"]!)
        ws["!autofilter"] = { ref: XLSX.utils.encode_range(range) }

        // widen columns
        ws["!cols"] = columns.map(() => ({ wch: 25 }))

        const borderStyle = {
          top: { style: "thin", color: { rgb: "#000000" } },
          bottom: { style: "thin", color: { rgb: "#000000" } },
          left: { style: "thin", color: { rgb: "#000000" } },
          right: { style: "thin", color: { rgb: "#000000" } }
        }

        // style header row
        newColumns.forEach((_, colIndex) => {
          const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex })
          if (ws[cellAddress]) {
            ws[cellAddress].s = {
              fill: { fgColor: { rgb: "1C6692" } },
              font: {
                bold: true,
                color: { rgb: "FFFFFF" }
              },
              border: borderStyle,
              alignment: {
                horizontal: "left",
                wrapText: false,
                shrinkToFit: true
              }
            }
          }
        })

        // alternating grey rows + borders
        data.forEach((row, rowIndex) => {
          if (rowIndex === 0) return

          for (let colIndex = 0; colIndex < newColumns.length; colIndex++) {
            const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex })

            if (!ws[cellAddress]) ws[cellAddress] = { t: "s", v: "" }
            if (!ws[cellAddress].s) ws[cellAddress].s = {}

            // odd rows → grey background
            if (rowIndex % 2 === 1) {
              ws[cellAddress].s.fill = { fgColor: { rgb: "E6E6E6" } }
            }

            // apply border
            ws[cellAddress].s.border = borderStyle

            // alignment
            ws[cellAddress].s.alignment = {
              horizontal: "left",
              wrapText: false,
              shrinkToFit: true
            }
          }
        })

        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, "SheetJS")
        XLSX.writeFile(wb, "EcoMobility_export.xlsx")

        setState(2)
      } catch {
        setState(3)
      }
    }, 200)
  }, [])

  return [state, exportTable]
}

export default useTableExport
